const BLOCK_TYPES = [
  { label: "Paragraph", variant: "body1", style: "paragraph" },
  { label: "Blockquote", variant: "body1", style: "blockquote" },
  { label: "H1", variant: "h1", style: "header-one" },
  { label: "H2", variant: "h2", style: "header-two" },
  { label: "H3", variant: "h3", style: "header-three" },
  { label: "H4", variant: "h4", style: "header-four" },
  { label: "H5", variant: "h5", style: "header-five" },
  { label: "H6", variant: "h6", style: "header-six" }
]
export default BLOCK_TYPES
